import React from 'react';
import './App.css';
import Navbar from './components/Navbar';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Projects from './components/pages/Projects/Projects';
import Blog from './components/pages/Blog/Blog';
import Contact from './components/pages/Contact/Contact';
import Home from './components/pages/Home/Home';


import { FooterContainer } from './containers/Footer';



function App() {
  return (
    <Router>
      <Navbar />
      <Switch>
        <Route path='/' exact component={Home} />
        <Route path='/projects' exact component={Projects} />
        <Route path='/blog' exact component={Blog} />
        <Route path='/contact-me' exact component={Contact} />
      </Switch>
      <FooterContainer />
    </Router>
  );
}

export default App;
